import * as r from 'ramda';

const pipePromise = (...args) => r.pipeWith(r.then)([...args]);

export { pipePromise };
